import { MAX_ENG_YEAR as e, MAX_NEP_YEAR as t, MIN_ENG_YEAR as n, MIN_NEP_YEAR as r } from "../constants/index.js";
import { zero_pad as i } from "../zero-pad/index.js";
// src/design/forms/datepicker/calendar-carburettor/is-date-in-conversion-range/index.ts
var a = (a, o) => {
	let [s, c, l] = a.split("-"), u = parseInt(`${s}${c}${l}`);
	if (o) {
		let e = parseInt(`${r}${i(1)}${i(1)}`), n = parseInt(`${t}${i(12)}${i(31)}`);
		return u >= e && u <= n;
	}
	{
		let t = parseInt(`${n}${i(4)}${i(13)}`), r = parseInt(`${e}${i(4)}${i(13)}`);
		return u >= t && u <= r;
	}
};
export { a as isDateInConversionRange };

//# sourceMappingURL=index.js.map